module.exports = __webpack_public_path__ + "static/media/YF46_3.1e0e9e73.jpg";